<template>
  <div class="exam-points">
    <div class="title">
      <img src="@/assets/img/weekReport/kaodian.png" alt="" />
      <h3>考点分析</h3>
    </div>
    <!-- 正常展示用 两个都有值 -->
    <dl class="subject" v-if="fenximathData.length > 0 && fenxienglishData.length > 0">
      <dd
        :class="[{ active: item.id === init }]"
        v-for="item in subject"
        :key="item.id"
        @click="onChangeTab(item)"
      >
        {{ item.tit }}
      </dd>
    </dl>
    <!-- 只有一个有值 -->
    <dl class="subject onlyOne">
      <dd v-if="fenximathData.length > 0 && fenxienglishData.length == 0">
        {{ '数学' }}
      </dd>
      <dd v-if="fenxienglishData.length > 0 && fenximathData.length == 0">
        {{ '英语' }}
      </dd>
    </dl>
    <!-- 数学 -->
    <div v-show="init == 0">
      <div class="analysis examPointsAnalysis">
        <ul v-html="fontTips1()"></ul>
      </div>
      <div class="line">
        <div id="shuxueexamPoints"></div>
      </div>
    </div>
    <!-- 英语 -->
    <div v-show="init == 1">
      <div class="analysis examPointsAnalysis">
        <ul v-html="fontTips2()"></ul>
      </div>
      <div class="line">
        <div id="yingyuexamPoints"></div>
      </div>
    </div>
  </div>
</template>
<script>
import { Bar } from '@antv/g2plot';
export default {
  props: {
    fenximathTitinfo: {
      type: Object,
      default: () => {},
    },
    fenxienglishTitinfo: {
      type: Object,
      default: () => {},
    },

    fenximathData: {
      type: Array,
      default: () => [],
    },
    fenxienglishData: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      init: 0,
      subject: [
        { id: 0, tit: '数学' },
        { id: 1, tit: '英语' },
      ],
    };
  },
  watch: {
    fenximathData(value) {
      if (value.length > 0) {
        this.initData1();
      }
    },
    fenxienglishData(value) {
      if (value.length > 0) {
        this.initData2();
      }
    },
  },

  mounted() {},
  methods: {
    onChangeTab(item) {
      this.init = item.id;
    },

    fontTips1() {
      let num = this.fenximathTitinfo?.knowledgeNum;
      let knowledgeNum = this.fenximathTitinfo?.knowledgeNum;
      let maxKnowledgeName = this.fenximathTitinfo?.maxKnowledgeName;
      let minKnowledgeName = this.fenximathTitinfo?.minKnowledgeName;
      let allright = this.fenximathData.some((item) => item.value != 100);
      let high =
        maxKnowledgeName == '' ? '' : `正确率最高的考点是<span>"${maxKnowledgeName}"</span>,`;
      let low = minKnowledgeName === '' ? '' : `正确率最低的是<span>"${minKnowledgeName}"</span>,`;
      let text = '';
      if (num > 2 && !allright) {
        text = `
        <li>
          本周所作答题目中,包含<span>${knowledgeNum}</span>个考点。你的努力得到了回报，全对的成绩是你最好的证明，继续保持！加油！
          </li>`;
      } else if (num <= 2) {
        text = `
        <li>
          本周所作答题目中,包含<span>${knowledgeNum}</span>个考点。本周作答涉考点较少,建议后续练习中,增加题目及考点的练习,综合复习、系统、全面提升。
          </li>`;
      } else if (num > 2 && num <= 10) {
        text = `<li>本周所作答题目中,包含<span>${knowledgeNum}</span>个考点。${high}${low}建议通过学习相关课程或增加刷题量来加强薄弱考点</li>`;
      } else {
        text = `
        <li>
          本周所作答题目中,包含<span>${knowledgeNum}</span>个考点。以下是本周所作答答题量最多的<span>${knowledgeNum}</span>个考点。${high}${low}建议通过学习相关课程或增加刷题量来加强薄弱考点
          </li>
       `;
      }

      return text;
    },
    fontTips2() {
      let num = this.fenxienglishTitinfo?.knowledgeNum;
      let knowledgeNum = this.fenxienglishTitinfo?.knowledgeNum;
      let maxKnowledgeName = this.fenxienglishTitinfo?.maxKnowledgeName;
      let minKnowledgeName = this.fenxienglishTitinfo?.minKnowledgeName;
      let allright = this.fenxienglishData.some((item) => item.value != 100);
      let high =
        maxKnowledgeName == '' ? '' : `正确率最高的考点是<span>"${maxKnowledgeName}"</span>,`;
      let low = minKnowledgeName === '' ? '' : `正确率最低的是<span>"${minKnowledgeName}"</span>,`;
      let text = '';
      if (num > 2 && !allright) {
        text = `
        <li>
          本周所作答题目中,包含<span>${knowledgeNum}</span>个考点。你的努力得到了回报,全对的成绩是你最好的证明,继续保持！加油！
          </li>`;
      } else if (num <= 2) {
        text = `
        <li>
          本周所作答题目中,包含<span>${knowledgeNum}</span>个考点。本周作答涉考点较少,建议后续练习中,增加题目及考点的练习,综合复习、系统、全面提升。
          </li>`;
      } else if (num > 2 && num <= 10) {
        text = `<li>本周所作答题目中,包含<span>${knowledgeNum}</span>个考点。${high}${low}建议通过学习相关课程或增加刷题量来加强薄弱考点</li>`;
      } else {
        text = `
        <li>
          本周所作答题目中，包含<span>${knowledgeNum}</span>个考点。以下是本周所作答答题量最多的<span>${knowledgeNum}</span>个考点。${high}${low}建议通过学习相关课程或增加刷题量来加强薄弱考点
          </li>
       `;
      }
      return text;
    },

    initData1() {
      let shuxueexamPoints = new Bar('shuxueexamPoints', {
        data: this.fenximathData,
        height: 220,
        xField: 'value',
        yField: 'year',
        seriesField: 'year',
        marginRatio: 0,
        dodgePadding:4,
        legend: false,
        color: ['#FF7634'],
        appendPadding:[0, 20, 0, 0],
        minBarWidth: 16,
        maxBarWidth: 16,
        label: {
          offsetX: -10,
          position: 'right', // 'left', 'middle', 'right'
          content: (item) => {
            return item.value + '%';
          },
        },
        barStyle: { radius: [10, 10, 10, 10] },
        xAxis: {
          label: {
            style: {
              fill: '#999',
              fontSize: 12,
              lineHeight:16,
              textAlign: 'left',
            },
            formatter: (item, value) => {
              return item + '%';
            },
          },
        },
        yAxis: {
          label: {
            style: {
              fill: '#999',
              fontSize: 12,
              lineHeight:16,
            },
            formatter(item) {
              return item.substring(0, 6) + '\n' +item.substring(6)
            },
          },
        },
      });

      shuxueexamPoints.render();
    },
    initData2() {
      let yingyuexamPoints = new Bar('yingyuexamPoints', {
        data: this.fenxienglishData,
        height: 220,
        xField: 'value',
        yField: 'year',
        seriesField: 'year',
        marginRatio: 0,
        dodgePadding: 4,
        legend: false,
        color: ['#FF7634'],
        appendPadding:[0, 20, 0, 0],
        label: {
          offsetX: -10,
          position: 'right', // 'left', 'middle', 'right'
          content: (item) => {
            return item.value + '%';
          },
        },
        barStyle: { radius: [10, 10, 10, 10] },
        minBarWidth: 16,
        maxBarWidth: 16,
        xAxis: {
          label: {
            formatter: (item, value) => {
              return item + '%';
            },
          },
        },
        yAxis: {
          label: {
            align:'left',
            formatter(item) {
              // 字符太长添加省略号
              return item.substring(0, 6) + '\n' +item.substring(6)
            },
          },
        },
      });

      yingyuexamPoints.render();
    },
  },
};
</script>

<style scoped lang="scss">
.exam-points {
  position: relative;
  width: 678px;
  background: #ffffff;
  box-shadow: 0px 4 11px 0px rgba(0, 0, 0, 0.02);
  border-radius: 14px;
  margin: 0 auto 20px;
  padding: 30px;

  .title {
    display: flex;
    align-items: center;
    margin-bottom: 30px;

    img {
      display: block;
      width: 30px;
      height: 30px;
      margin-right: 7px;
    }

    h3 {
      font-size: 29px;
      font-weight: 500;
      color: #333333;
    }
  }

  .subject {
    display: flex;
    justify-content: center;
    margin-bottom: 60px;

    dd {
      width: 116px;
      height: 49px;
      line-height: 49px;

      border: 2px solid #e4e4e4;
      font-size: 22px;
      font-weight: 400;
      color: #999999;
      text-align: center;
    }

    dd:first-of-type {
      border-radius: 14px 0px 0px 14px;
    }

    dd:last-of-type {
      border-radius: 0px 14px 14px 0px;
    }

    .active {
      background: #ff7f41;
      color: #fff;
      border: none;
    }
  }

  .subject2 {
    display: flex;
    justify-content: center;
    margin-bottom: 60px;

    dd {
      width: 116px;
      height: 49px;
      line-height: 49px;
      border-radius: 14px;
      font-size: 22px;
      font-weight: 400;
      background: #ff7f41;
      color: #fff;
      text-align: center;
    }
  }

  .analysis {
    ul {
      li {
        position: relative;
        font-size: 25px;
        font-weight: 400;
        color: #333333;
        margin-bottom: 20px;
        padding-left: 26px;
        line-height: 34px;

        span {
          color: #ff3938;
        }
      }
    }
  }

  .line {
    margin: 40px auto;
  }

  .onlyOne {
    margin-bottom: 0px;
    dd {
      border-radius: 14px !important;
      background: #ff7f41;
      color: #fff;
      border: none;
    }
  }
}
</style>

<style lang="scss">
.examPointsAnalysis {
  ul {
    li {
      position: relative;
      font-size: 25px;
      font-weight: 400;
      color: #333333;
      margin-bottom: 20px;
      padding-left: 26px;
      line-height: 34px;

      span {
        color: #ff3938;
      }
    }
  }
}
</style>
